import { atom } from 'jotai';
import { $ArticleRelatedPost, IArticleRelatedPost } from 'shared/atoms';
import { safeAtomFamily } from 'shared/utils/safe-atom-family';

export const $ArticleRelatedPostLoadmore = safeAtomFamily((groupId: string) => {
  const a = atom(null, async (get, set, input: IArticleRelatedPost) => {
    const { items, searchId } = await get($ArticleRelatedPost(groupId));

    set($ArticleRelatedPost(groupId), {
      ...input,
      items: [...items, ...input.items],
      searchId, // searchId remains unchanged when load more
    });
  });

  a.debugLabel = `$ArticleRelatedPostLoadmore+${encodeURIComponent(groupId)}`;

  return a;
});
